import React, { useRef } from 'react';
import { ShareIcon } from '../../Brand/Icon';
import message from '../../Brand/brandMessage';
import { publicShareUrl, shareLink } from '../../../utils/shareLink';
import { useTranslation } from 'react-i18next';
import '../index.scss';

export default function ButtonShare({ shareUrl, shareTitle, shareText, shareContext }) {
  const { t } = useTranslation();
  const pending = useRef(false);
  const share = async () => {
    if (pending.current) return;
    pending.current = true;
    try {
      const title = shareTitle || document.title;
      const result = await shareLink({ title, text: shareText ?? title, url: publicShareUrl(shareUrl) }, shareContext);
      if (result === 'copied') message.success(t('brand:shareCopied'));
    } catch (error) {
      message.error(t(error?.code === 'SHARE_COPY_FAILED' ? 'brand:shareCopyError' : 'brand:shareError'));
    } finally {
      pending.current = false;
    }
  };

  return <button type="button" className="wiw-icon-button"
    aria-label={t('common.share', { defaultValue: 'Share' })} onClick={share}>
    <ShareIcon className="nav-icon" aria-hidden="true" />
  </button>;
}
